<template>
  <div
    v-if="party?.Address && party.locationReveled"
    outlined
    class="rounded-lg"
  >
    <div class="d-flex gap-4">
      <div class="flex-grow-1 flex-shrink-1 align-self-center">
        <div style="display: grid">
          <b class="mb-0 black--text lh-1">Endereço</b>
          <h6 class="black--text mb-0 text-truncate">
            {{ this.party?.Address?.name }}
          </h6>
          <p class="mb-0 lh-2">{{ this.fullAddress }}</p>
        </div>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <v-card elevation="0" class="pa-1 pb-0 rounded">
          <div style="position: relative">
            <qrcode-vue
              style="
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=);
                background-size: cover;
              "
              class="d-flex justify-center white rounded"
              :value="mapsLink"
              size="70"
              level="M"
              renderAs="svg"
            />
            <div
              class="d-flex justify-center align-center"
              style="position: absolute; top: 0; right: 0; bottom: 0; left: 0"
            >
              <v-avatar size="18" color="white">
                <v-icon size="14" color="primary"> mdi-map-marker </v-icon>
              </v-avatar>
            </div>
          </div>
          <small class="text-center d-block" style="font-size: 9px">Rota</small>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: { QrcodeVue },
  data() {
    return {};
  },
  methods: {},
  computed: {
    mapsLink() {
      let address = this.geometry
        ? `${this.geometry.lat},${this.geometry.lng}`
        : this.fullAddress;
      let url = `https://www.google.com/maps/dir/?api=1&parameters&destination=${address}`;
      return new URL(url).href;
    },
  },

  filters: {},
  props: {
    party: {
      type: Object,
      required: true,
    },
    images: {
      type: Object,
      required: true,
    },
    fullAddress: {
      type: String,
    },
    geometry: {
      type: Object,
    },
  },
};
</script>

<style scoped>
p {
  display: block;
}
</style>
